import {
  SupportTypes,
  BaseOptions,
} from '@ks/weblogger/dist/log.bridge.common.js';
import { WebLogger } from './weblogger';
import { App } from 'vue';

export type TypeName = SupportTypes;

export interface Content {
  // 活动id
  activityId?: any;
  // 来源
  source?: string | 'unknown';
  // 其他的参数可有可无
  [key: string]: any;
}

const contentPackagSourceCache: {
  source: string;
} = {
  source: 'unknow',
};

export const logger = (function () {
  const log = new WebLogger();

  // 添加项目名称自定义维度
  if (log.logger.plugins.radar) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    log.logger.plugins.radar.setDimensions({
      c_dimension1: 'll-merchant',
    });
  }

  return log;
})();

export const updateCurrentUrlPackage = (url: string | object) => {
  logger.updateCurrentUrlPackage(url);
};

// 更新weblogger配置
export const updateWebLoggerCommonPackage = (options: any) => {
  logger.updateCommonPackage(options);
};

export const updateConstContentPackage = (params: Content) => {
  const { source } = params;
  if (source) {
    contentPackagSourceCache.source = source;
  }
};

export const pageShowLog = (params: any = {}) => {
  logger.sendImmediately('PV', {
    type: 'enter',
    params,
  });
};

/**
 * 点击事件
 */
export const clickLog = (
  elementPackageAction: string,
  elementPackageParams: any = {}
) => {
  logger.sendImmediately('CLICK', {
    action: elementPackageAction,
    params: elementPackageParams,
  });
};

/**
 * Task事件
 */
export const clickTaskLog = (
  elementPackageAction: string,
  elementPackageParams: any = {}
) => {
  logger.sendImmediately('CLICK', {
    action: elementPackageAction,
    params: elementPackageParams,
    type: 'BACKGROUND_TASK_EVENT',
  });
};

/**
 * 业务自定义事件 上报到雷达自定义监控
 */
export const customTaskLog = (
  elementPackageAction: string,
  elementPackageParams: any = {}
) => {
  logger.sendImmediately('CUSTOM_EVENT', {
    action: elementPackageAction,
    params: elementPackageParams,
  });
};

/**
 * 页面元素曝光事件
 */
export const showLog = (
  elementPackageAction: string,
  elementPackageParam: any = {}
) => {
  logger.sendImmediately('SHOW', {
    action: elementPackageAction,
    params: elementPackageParam,
  });
};

export const fmpEvent = () => {
  const radar = logger.logger?.plugins?.radar;
  if (radar && process.env.NODE_ENV == 'production') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (radar as any).fmp();
  }
};

export const sendCustomLog = (metricKey: string, metricValue: number) => {
  try {
    const radar = logger.logger?.plugins?.radar;
    if (radar) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (radar as any).collect(metricKey, metricValue);
    }
  } catch (e) {
    console.error('weblogger 自定义上报埋点报错');
  }
};

export const sendCustomEvent = (
  name: string,
  params?: { [key: string]: any },
  duration?: number
) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const event = logger.logger?.plugins?.radar?.event;
    if (event) {
      const assembleParam: Array<{ [key: string]: any }> = [
        { ...params, name },
      ];
      duration && assembleParam.push({ duration });
      event(...assembleParam);
    }
  } catch (e) {
    console.error('weblogger 自定义上报埋点报错');
  }
};

export const sendCustomActionStart = (
  name: string,
  params?: { [key: string]: any }
) => {
  if (process.env.NODE_ENV !== 'production') {
    // 非线上不上报
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  logger?.logger?.plugins?.radar?.action?.start({ name, extra_info: params });
};

export const sendCustomActionEnd = (
  name: string,
  params?: { [key: string]: any },
  successful?: boolean
) => {
  if (process.env.NODE_ENV !== 'production') {
    // 非线上不上报
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (
    logger.logger.plugins &&
    logger.logger.plugins.radar &&
    logger.logger.plugins.radar.action
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    logger.logger.plugins.radar.action.end({
      name,
      extra_info: params,
      result_type: successful,
    });
  }
};

/**
 * 自定义错误埋点上报
 */

export const initErrorHandlerLog = (vm: App) => {
  const _oldOnError = vm.config.errorHandler;

  // 雷达上报错误
  vm.config.errorHandler = function (err, vm, info) {
    // radar 线上上报
    if (process.env.NODE_ENV === 'production') {
      logger.logger.plugins.radar?.captureException(err);
    }

    // 执行原来的 错误执行函数
    if (typeof _oldOnError === 'function') {
      _oldOnError.call(this, err, vm, info);
    }

    // 输出控制台
    if (process.env.NODE_ENV !== 'production') {
      console.error(err);
    }
  };
};
